import React from 'react';
export function SectionDivider() {
  return <div className="w-full max-w-4xl mx-auto py-16 md:py-24 px-4" data-id="element-434">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-amber/50 to-transparent opacity-50" data-id="element-435" />
    </div>;
}